module.exports = __webpack_public_path__ + "static/media/double-right.47dc7138.svg";